import { CalendarDays, CalendarCheck2, Home, UserRound, UsersRound, type LucideIcon } from "lucide-react";
import type { MobileRole } from "./access";

export type AppTabId = "home" | "agenda" | "activity" | "profile";

export interface AppTab {
  id: AppTabId;
  label: string;
  icon: LucideIcon;
}

const HOME_TAB: AppTab = { id: "home", label: "Início", icon: Home };
const PROFILE_TAB: AppTab = { id: "profile", label: "Perfil", icon: UserRound };

const MEMBER_TABS: readonly AppTab[] = [
  HOME_TAB,
  { id: "agenda", label: "Aulas", icon: CalendarDays },
  { id: "activity", label: "Reservas", icon: CalendarCheck2 },
  PROFILE_TAB,
];

const COACH_TABS: readonly AppTab[] = [
  HOME_TAB,
  { id: "agenda", label: "Agenda", icon: CalendarDays },
  { id: "activity", label: "Turmas", icon: UsersRound },
  PROFILE_TAB,
];

export function tabsForRole(role: MobileRole): readonly AppTab[] {
  return role === "member" ? MEMBER_TABS : COACH_TABS;
}

export function tabById(role: MobileRole, tabId: AppTabId): AppTab {
  return tabsForRole(role).find(tab => tab.id === tabId) ?? HOME_TAB;
}
